// extracted by extract-css-chunks-webpack-plugin
module.exports = {"products":"css-2bcG7-4J8S","products__alignFull":"css-1l6idWOtRG"};